<template>
  <div class="page-add">
    <div class="add-title">新增讲师</div>
    <div class="content">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="form"
        size="small"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="讲师姓名：" prop="lecturerName">
              <el-input
                placeholder="请输入讲师姓名"
                v-model="ruleForm.lecturerName"
                @blur="validateName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="师资分类：" prop="categoryId">
              <el-cascader
                v-model="ruleForm.categoryId"
                :options="typeList"
                :props="props"
                placeholder="请选择类型"
                clearable
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              class="scale"
              label="头像："
              prop="avatarUrl"
              :show-message="showError"
            >
              <av-preview
                v-if="ruleForm.avatarUrl"
                :src="ruleForm.avatarUrl"
                type="image"
                @delete="deleteCover"
              />
              <upload
                v-else
                :draggable="false"
                :path="'lecturer/img'"
                type="image"
                v-model="ruleForm.covers"
              />
              <div style="font-size: 12px;">建议尺寸：270px*360px（或3:4）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="讲师职务：" prop="lecturerPost">
              <el-input
                type="textarea"
                v-model="ruleForm.lecturerPost"
                maxlength="500"
                rows="3"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="讲师简介：" prop="lecturerDesc">
              <el-input
                type="textarea"
                v-model="ruleForm.lecturerDesc"
                maxlength="500"
                rows="5"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item class="center">
              <el-button @click="reset">重置</el-button>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <back-button :pathOptions="pathOptions" :floatLeft="false" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>存在同名讲师，是否继续使用？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearName">否</el-button>
        <el-button type="primary" @click="dialogVisible = false">是</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  lecturerTypeTree,
  lecturerSave,
  validateLecturerName,
} from "@/api/lecturer";
import { getLecturerParamList } from "@/api/lecturer";
import rulesFactory from "@/utils/rules";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index.vue";

export default {
  components: { Upload, AvPreview, BackButton },
  name: "addLecture",
  data() {
    return {
      pathOptions: {
        path: "/lecturer",
      },
      dialogVisible: false,
      page: "",
      rules: {
        lecturerName: [
          {
            required: true,
            message: "请输入讲师姓名",
            trigger: ["blur", "change"],
          },
          rulesFactory.size("最多输入20个字", 0, 20),
        ],
        categoryId: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        lecturerPost: [
          {
            required: true,
            message: "请输入讲师职务",
            trigger: ["blur", "change"],
          },
        ],
      },
      lecturerInfor: "",
      lecturerData: "",
      ruleForm: {
        lecturerName: "",
        categoryId: "",
        lecturerDesc: "",
        lecturerPost: "",
        avatarUrl: "",
        covers: [],
      },
      typeList: [],
      array: "",
      props: {
        //树形
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },
      showError: false,
    };
  },
  created() {
    lecturerTypeTree().then((res) => {
      this.typeList = res.data;
    });
  },
  watch: {
    "ruleForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.ruleForm.avatarUrl = val[0].url;
          this.showError = false;
        } else {
          this.ruleForm.avatarUrl = "";
          this.showError = true;
        }
      },
    },
  },
  methods: {
    clearName() {
      this.ruleForm.lecturerName = "";
      this.dialogVisible = false;
    },
    validateName() {
      let name = this.ruleForm.lecturerName;
      setTimeout(() => {
        if (name) {
          validateLecturerName(name).then(({ code, data }) => {
            if (code !== 0) return;
            this.dialogVisible = data;
          });
        }
      }, 200);
    },
    // 删除封面
    deleteCover() {
      // 清空已上传的文件列表
      this.ruleForm.covers = [];
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.ruleForm.covers = [];
        this.$refs["ruleForm"].resetFields();
      });
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            let parentId = this.ruleForm.categoryId;
            // 级联选择返回parentId为数组，这里进行赋值
            if (typeof parentId == "object") {
              this.ruleForm.categoryId = parentId[Number(parentId.length - 1)];
            }
            let params = { ...this.ruleForm };
            delete params.covers;
            lecturerSave(params).then((res) => {
              if (!res || res.code != 0) return;
              if (res.code == 0) {
                this.page = this.$route.query.page;
                if (this.page == 2) {
                  getLecturerParamList("").then((res) => {
                    if (!res || res.code != 0) return;
                    this.lecturerData = res.data.records;
                    this.array = this.lecturerData.filter((item) => {
                      return item.lecturerName == this.ruleForm.lecturerName;
                    });
                    this.$router.push({
                      path: "/video/add",
                      query: {
                        lecturerId: this.array[0].uuid,
                        lecturerName: this.array[0].lecturerName,
                        lecturerDesc: this.array[0].lecturerDesc,
                      },
                    });
                  });
                } else {
                  setItem(this.REFRESH_FLAG, true);
                  this.$router.back();
                }
              }
            });
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.img_tip {
  font-size: 12px;
  color: #666;
}
/deep/ .center {
  margin-top: 30px !important;
  text-align: center;
}
</style>
